import Vue from 'vue';
import Vuex from 'vuex';
import persistedState from 'vuex-persistedstate';

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  currentMenu: {},
  userInfo: {},
  currentOpenMenu: '/dashboard',
  showSideNav: false,
  currentProjectId: window.localStorage.getItem('CURRENT_PROJECT_ID') || '',
  authUrlList: {},
  globalEnumCollection: {
    accountStatusEnum: {
      0: '已禁用',
      1: '正常',
      2: '已删除',
    },
    accountTypeEnum: {
      10: '超级管理员',
      20: 'CDC用户',
      21: 'POV用户',
    },
    accountTypeEnumByAdmin: {
      20: 'CDC用户',
      21: 'POV用户',
    },
    accountTypeEnumByCompany: {
      21: 'POV用户',
    },
    wareHouseTypeEnum: {
      1: '制冷库',
      2: '常温库',
    },
    onlineFlagEnum: {
      0: '离线',
      1: '在线',
    },
    deviceTypeEnum: {
      0: '独立探头',
      1: '非独立探头',
      2: '基站',
    },
    alarmTypeEnum: {
      1: '温度超限',
      2: '湿度超限',
      3: '低电',
      4: '断电',
      5: '离线',
    },
    alarmExecutorTypeEnum: {
      1: '短信',
      2: '邮件',
      3: '微信公众号',
      4: '语音',
    },
    readStatusEnum: {
      0: '未确认',
      1: '误报',
      2: '稍后处理',
      3: '已处理',
    },
    readNotOverTempStatusEnum: {
      0: '未确认',
      1: '误报',
      3: '已处理',
    },
    recoverStatusEnum: {
      0: '未恢复',
      1: '已恢复',
    },
    locationAreaEnum: {
      1: '预冷区',
      2: '释冷区',
      3: '打包区',
      4: '回收区',
    },
    iceBoxProcessStatusEnum: {
      0: '总冰盒',
      1: '待预冷',
      2: '预冷中',
      3: '预冷完成',
      4: '释冷中',
      5: '释冷完成',
      6: '释冷过久',
      7: '运输中',
      8: '运输完成',
    },
    iceBoxProcessStatusWithoutSiteEnum: {
      1: '待预冷',
      2: '预冷中',
      3: '预冷完成',
      4: '释冷中',
      5: '释冷完成',
      6: '释冷过久',
    },
    transportStatusEnum: {
      0: '待运输',
      1: '运输中',
      2: '运输完成',
      3: '取消运输',
    },
    sendParamStatusEnum: {
      0: '未下发',
      1: '下发失败',
      2: '下发完成',
      3: '下发中',
    },
    boxStatusEnum: {
      1: '可用',
      2: '在运',
      3: '待回收',
    },
    boxRecycleStatusEnum: {
      0: '未回收',
      1: '已回收',
    },
    iceBoxRecycleStatusEnum: {
      0: '未回收',
      1: '已回收',
    },
    deviceRecycleStatusEnum: {
      0: '未回收',
      1: '已回收',
    },
    tempStatusEnum: {
      1: '正常',
      2: '超温',
    },
    assetTypeEnum: {
      0: '箱子',
      1: '冰盒',
      2: '记录仪',
      3: '冰盒架',
      4: '冰盒托盘',
      5: '冰盒筐',
    },
    operateTypeEnum: {
      1: '入库',
      2: '出库',
      3: '打包',
      4: '回收',
    },
    // 冰盒出入库的载体类型
    carrierTypeEnum: {
      1: '冰盒架',
      2: '冰盒托盘',
      3: '筐',
      4: '/',
    },
    // 时间类型
    timeTypeEnum: {
      0: '年',
      1: '月',
      2: '日',
    },
    // 资产归属
    belongToTypeEnum: {
      0: '分配',
      1: '自购',
    },
    deviceTempStatusEnum: {
      0: '正常',
      1: '超温',
      2: '长时超温',
    },
    methodEnum: {
      POST: '添加',
      DELETE: '删除',
      PUT: '修改',
      GET: '查询',
    },
    resultEnum: {
      0: '失败',
      1: '成功',
    },
    // 短信充值
    smsRechargeEnum: {
      1: '充值',
      2: '返还',
    },
  },
  menuList: [
    { icon: 'el-icon-monitor', title: '设备查看', url: '/transport-monitor-forDeviceUser', authUserType: [40] },
    { icon: 'el-icon-odometer', title: '数据看板', url: '/dashboard', authUserType: [10, 20, 21] },
    {
      icon: 'el-icon-monitor',
      title: '探头监控',
      url: '/transport',
      authUserType: [10, 20, 21],
      children: [
        /* {
          title: '运输列表',
          url: '/transport-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '运输监控',
          url: '/transport-monitor',
          authUserType: [10, 20, 21],
        },
        {
          title: '运单管理',
          url: '/transportOrder-list',
          authUserType: [10, 20, 21],
        }, */
        {
          title: '探头监控',
          url: '/device-monitor',
          authUserType: [10, 20, 21],
        },
        {
          title: '分组管理',
          url: '/group-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '分组设备',
          url: '/group-device',
          authUserType: [10, 20, 21],
        },
      ],
    },
    /* { icon: 'el-icon-receiving', title: '冰盒流程管理', url: '/iceBox-process', authUserType: [10, 20, 21] },
    {
      icon: 'el-icon-office-building',
      title: '库房管理',
      url: '/location',
      authUserType: [10, 20, 21],
      children: [
        {
          title: '库房设置',
          url: '/location-list',
          authUserType: [10, 20, 21],
        },
      ],
    }, */
    {
      icon: 'el-icon-receiving',
      title: '设备参数',
      url: '/param',
      authUserType: [10, 20, 21],
      children: [
        {
          title: '探头参数',
          url: '/device-param',
          authUserType: [10, 20, 21],
        },
        {
          title: '基站参数',
          url: '/baseStation-param',
          authUserType: [10, 20, 21],
        },
      ],
    },
    /* { icon: 'el-icon-coin', title: '资产管理', url: '/333-list' }, */
    {
      icon: 'el-icon-coin',
      title: '资产管理',
      url: '/assets',
      authUserType: [10, 20, 21],
      children: [
        /* {
          title: '仓库管理',
          url: '/warehouse-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '冰箱管理',
          url: '/fridge-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '箱管理',
          url: '/box-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '冰盒管理',
          url: '/iceBox-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '冰盒架',
          url: '/iceBoxShelf-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '冰盒托盘',
          url: '/iceBoxPallet-list',
          authUserType: [10, 20, 21],
        }, */
        {
          title: '探头管理',
          url: '/device-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '基站管理',
          url: '/baseStation-list',
          authUserType: [10, 20, 21],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '机构设备',
          url: '/unit-list',
          authUserType: [10, 20, 21],
        },
      ],
    },
    {
      icon: 'el-icon-bell',
      title: '报警管理',
      url: '/alarm',
      authUserType: [10, 20, 21],
      children: [
        {
          title: '报警信息管理',
          url: '/alarm-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '报警项目管理',
          url: '/alarmExecutor-list',
          authUserType: [10, 20, 21],
        },
        {
          title: '探头批量报警',
          url: '/device-batch-alarm',
          authUserType: [10, 20],
        },
        {
          title: '基站批量报警',
          url: '/baseStation-batch-alarm',
          authUserType: [10, 20],
        },
      ],
    },
    {
      icon: 'el-icon-s-tools',
      title: '系统管理',
      url: '/config',
      authUserType: [10, 20],
      children: [
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '账号管理',
          url: '/account-list',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '日志管理',
          url: '/log-list',
          authUserType: [10, 20, 21],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'CDC管理',
          url: '/company-list',
          authUserType: [10],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'POV管理',
          url: '/station-list',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'CDC短信',
          url: '/company-sms-recharge-list',
          authUserType: [10],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '短信记录',
          url: '/sms-send-log-list',
          authUserType: [10, 20, 21],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: 'CDC语音',
          url: '/company-voice-recharge-list',
          authUserType: [10],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '语音记录',
          url: '/voice-send-log-list',
          authUserType: [10, 20, 21],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '全局配置',
          url: '/mail-config',
          authUserType: [10, 20],
        },
        {
          icon: 'fa fa-fw fa-1x fa-mortar-board',
          title: '设备型号',
          url: '/deviceModel-list',
          authUserType: [10],
        },
      ],
    },
  ],
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  strict: process.env.NODE_ENV !== 'production',
  plugins: [persistedState({ storage: window.sessionStorage })],
});



// WEBPACK FOOTER //
// ./src/store/index.js